import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'
import client from '../../LikePlusClient'
import { searchTaxes, redemptionCard } from 'features/LikePlus/ducks'
import { Button } from 'loyal-react'

import { features, ToggleFeature } from 'features/ToggleFeature'

import { SecondFactorAuthentication } from 'features/Checkout/SecondFactorAuthenticaton'
import { actions } from 'features/Checkout'

class RequestAside extends Component {
  constructor (props) {
    super(props)

    this.state = {
      name: this.props.participant.name.value,
      cpf: this.props.participant.cpf.value,
      emissionRate: 0,
      emissionRateMiles: 0,
      freight: 0,
      freightMiles: 0,
      showRegulation: false
    }
    this.handleRegulation = this.handleRegulation.bind(this)
    this.handleTotalPoints(0)
    this.finishRescue = this.finishRescue.bind(this)
    this.props.searchTaxes()
  }

  componentDidMount () {
    this.handleCardTaxes()
  }

  componentDidUpdate (prev) {
    let cardTaxes = this.props.cardTaxes
    if (cardTaxes && (prev.cardTaxes !== cardTaxes)) {
      this.handleCardTaxes()
    }

    let order = this.props.order
    if (order && (prev.order !== order)) {
      this.handleOrderFinish()
    }
  }

  handleRegulation = () => {
    this.setState({ showRegulation: !this.state.showRegulation })
  }
  handleTotalPoints (totalCost) {
    this.props.handleTotalPoints(totalCost)
  }

  handleCardTaxes () {
    if (this.props.cardTaxes) {
      let cardTaxes = this.props.cardTaxes
      if (cardTaxes.success) {
        let frete = cardTaxes.partnerTax.filter((e, index) => {
          return e.taxType === 1
        })
        let taxaEmissao = cardTaxes.partnerTax.filter((e, index) => {
          return e.taxType === 2
        })
        if (frete && frete.length) {
          this.handlefreight(frete[0].points)
          this.handlefreightMiles(frete[0].miles)
        }
        if (taxaEmissao && taxaEmissao.length) {
          this.handleEmissionRate(taxaEmissao[0].points)
          this.handleEmissionRateMiles(taxaEmissao[0].miles)
        }
      } else {
        this.handleAlert(true, true, 'Oops !!!', 'Houve algum erro ao buscar as taxas do cartão. Por favor tente novamente.')
      }
    }
  }

  handleEmissionRate = (emissionRate) => {
    this.setState({ emissionRate })
  }

  handleEmissionRateMiles = (emissionRateMiles) => {
    this.setState({ emissionRateMiles })
  }

  handlefreight = (freight) => {
    this.setState({ freight })
  }

  handlefreightMiles = (freightMiles) => {
    this.setState({ freightMiles })
  }

  async convertPoints (points) {
    let res = await client.pointsToCash(points, this.props.accessToken)
    return res !== undefined && res.money >= 0 ? res.money : 0
  }

  async finishRescue () {
    if (this.props.initialCredit > 0 && this.props.disabledConfirmButton === false) {
      const totalCost = this.getTotalPoints()
      if ((totalCost <= this.props.balance.pointsValue)) {
        this.props.handleDisabledConfirmButton(true)
        const payload = await this.createPayload()
        console.log(payload)
        this.props.redemptionCard(payload)
      } else {
        this.handleAlert(true, true, 'Oops !!!', 'O valor a ser creditado é maior do que o saldo disponivel, por favor revise a quantidade ou consiga mais saldo')
      }
    }
  }
  handleOrderFinish () {
    let order = this.props.order
    if (order.success) {
      this.handleAlert(true, false, 'Sucesso !!!', 'Seu cartão foi requisitado com sucesso')
      this.props.handleSuccess(true)
      this.props.handleTransactionId(order.liveOrderId)
      const totalCost = this.getTotalPoints()
      if ((totalCost <= this.props.balance.pointsValue)) {
        this.props.handleTotalPoints(totalCost)
      }
    } else {
      this.props.handleSuccess(false)
      this.props.handleDisabledConfirmButton(false)
    }
  }
  async createPayload () {
    let cpf = this.props.participant.cpf.value
    let name = this.props.participant.name.value
    let obj = {
      totalMiles: await this.getTotalMiles(),
      totalPoints: this.getTotalPoints(),
      transferKey: 'cpf',
      loyaltyNumber: cpf,
      cpf: cpf,
      participantName: name,
      offline: false,
      orderItems: [],
      orderTypeId: 3
    }

    return this.validatePoints(obj)
  }

  validatePoints (obj) {
    if (this.state.freight > 0 && this.state.emissionRate > 0) {
      obj.orderItems.push(this.getPoints(), this.getFreigth(), this.getEmissionRate())
    } else if (this.state.freight > 0) {
      obj.orderItems.push(this.getPoints(), this.getFreigth())
    } else if (this.state.emissionRate > 0) {
      obj.orderItems.push(this.getPoints(), this.getEmissionRate())
    } else {
      obj.orderItems.push(this.getPoints())
    }

    return obj
  }

  getPoints () {
    let points = parseFloat(this.props.initialCredit)
    let miles = parseFloat(this.props.initialMiles)
    let obj = {
      quantity: 1,
      points: points,
      miles: miles,
      totalPoints: points,
      packageName: `${points} Pontos Like+`
    }

    return obj
  }

  getFreigth () {
    let points = this.state.freight
    let miles = this.state.freightMiles
    let obj = {
      quantity: 1,
      points: points,
      miles: miles,
      totalPoints: points,
      packageName: `${points} Pontos Like+`,
      pointsAdjustment: 0,
      taxTypeId: 1
    }

    return obj
  }

  getEmissionRate () {
    let points = this.state.emissionRate
    let miles = this.state.emissionRateMiles
    let obj = {
      quantity: 1,
      points: points,
      miles: miles,
      totalPoints: points,
      packageName: `${points} Pontos Like+`,
      pointsAdjustment: 0,
      taxTypeId: 2
    }

    return obj
  }

  getTotalPoints () {
    return this.state.emissionRate + this.state.freight + (!isNaN(this.props.initialCredit) ? parseFloat(this.props.initialCredit) : 0)
  }

  async getTotalMiles () {
    // let miles = await this.convertPoints(this.getTotalPoints())
    // return miles

    let miles = this.state.freightMiles + this.state.emissionRateMiles + parseFloat(this.props.initialMiles)

    return miles
  }

  handleAlert (show, isError, title, message) {
    let alert = {
      show,
      isError,
      title,
      message
    }
    this.props.handleAlert(alert)
  }

  getDate () {
    return moment().format('LLL')
  }

  convertMoney = (value, minimumDigits = 2, maximumDigits = 2) => {
    return value.toLocaleString('pt-br', {
      minimumFractionDigits: minimumDigits,
      maximumFractionDigits: maximumDigits
    })
  }
  render () {
    return (
      <Fragment>
        <div className='border-color-ui-3 bg-white border px-3 py-4'>
          {this.props.success
            ? (<h3>Sobre a solicitação</h3>)
            : (<h3>Resumo da solicitação</h3>)
          }
        </div>
        <div className='border-color-ui-3 bg-ui-4 p-0 col-12 border-right border-left'>
          <div className='border-bottom border-color-ui-3 px-3 py-2'>
            <p className='mb-2'><strong>Cartão Like Mais</strong></p>
            {
              this.props.success && (<p>Realizado em: <strong>{this.getDate()}</strong></p>)
            }
            <p>Taxa de emissão: <strong>{this.state.emissionRate} pontos</strong></p>
            <p>Frete: <strong>{this.state.freight} pontos</strong></p>
            <p>Crédito inicial: <strong>{this.props.initialCredit} pontos</strong></p>
            {
              this.props.success &&
              <p>Total de pontos utilizados:
                <strong>
                  { this.getTotalPoints() } pontos
                </strong>
              </p>
            }
            <p>Valor em reais a ser creditado: <strong>R$ {this.convertMoney(this.props.initialMiles, 2, 2)}</strong></p>
          </div>
          <div className='px-3 py-2'>
            <p>Solicitante: <strong>{this.state.name}</strong></p>
            <p>CPF: <strong>{this.state.cpf}</strong></p>
          </div>
        </div>
        <div className='border-color-ui-3 p-0 col-12 bg-white border'>
          {
            !this.props.success &&
            <div className='d-flex justify-content-between px-3 py-2'>
              <p>Total de pontos utilizados</p>
              <p>
                <strong>
                  { this.getTotalPoints() } pontos
                </strong>
              </p>
            </div>
          }
          <div className='px-3 py-2'>
            {this.props.success ? (
              <Fragment>
                <button className='btn btn-featured btn-icon txt-button txt-font-body' onClick={() => window.print()}>
                  <i className='icon icon_copy' aria-hidden='true' /> IMPRIMIR PEDIDO
                </button>
              </Fragment>
            ) : (
              <Fragment>
                <p className='mb-2'>Ao finalizar declaro que li e aceito os <a href='javascript:void(0)' onClick={this.handleRegulation} className='cursor txt-underline color-brand-2-like'>termos do regulamento.</a></p>
                <Button
                  className='btn btn-featured btn-icon txt-button txt-font-body'
                  onClick={this.finishRescue}
                  disabled={this.props.disabledConfirmButton}
                  text={'FINALIZAR RESGATE'}
                  loading={this.props.loading}
                  iconName='icon icon_gift'
                  role='button'
                />
                <ToggleFeature feature={features.LikePlusModalRegulation} isOpen={this.state.showRegulation} handleClose={this.handleRegulation} />
              </Fragment>
            )}
            {this.props.secondFactorAuthentication && this.props.secondFactorAuthentication.enable && (
              <div className='modalConfirmationVoucher'>
                <SecondFactorAuthentication
                  {...this.props}
                  show={this.props.secondFactorAuthentication.enable}
                  secondFactorAuthConfirmated={this.props.secondFactorAuthentication.AuthenticationConfirmed}
                  confirmedOrderId={this.props.secondFactorAuthentication.confirmedOrderId}
                  oidc={this.props.oidc}
                  paymentSelected='POINTS_ONLY'
                  closeModal={this.props.closeModal}
                  authorizeWithTokenResend={this.props.authorizeWithTokenResend}
                  authorizeWithToken={this.props.authorizeWithToken}
                  authorizeWithTokenLastTry={this.props.authorizeWithTokenLastTry}
                  isCreatingPurchase={this.props.isCreatingPurchase}
                  errorToken={this.props.errorToken}
                  phone={this.props.secondFactorAuthentication.phone}
                />
              </div>
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

RequestAside.propTypes = {
  initialCredit: PropTypes.number,
  initialMiles: PropTypes.number,
  success: PropTypes.bool,
  participant: PropTypes.object,
  handleSuccess: PropTypes.func,
  handleTotalPoints: PropTypes.func,
  accessToken: PropTypes.string,
  balance: PropTypes.object,
  handleAlert: PropTypes.func,
  handleTransactionId: PropTypes.func,
  disabledConfirmButton: PropTypes.bool,
  handleDisabledConfirmButton: PropTypes.func,
  searchTaxes: PropTypes.func,
  cardTaxes: PropTypes.object,
  redemptionCard: PropTypes.func,
  order: PropTypes.object,
  secondFactorAuthentication: PropTypes.object,
  oidc: PropTypes.object,
  closeModal: PropTypes.func,
  authorizeWithToken: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithTokenLastTry: PropTypes.func,
  isCreatingPurchase: PropTypes.func,
  errorToken: PropTypes.func,
  loading: PropTypes.bool
}

const mapStateToProps = ({ likeplus, oidc }) => ({
  ...likeplus,
  oidc
})

const mapDispatchToProps = dispatch => ({
  searchTaxes: () => dispatch(searchTaxes()),
  redemptionCard: (order) => dispatch(redemptionCard(order)),
  authorizeWithToken: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend,
    lastTry = false
  ) =>
    dispatch(
      actions.authorizeWithToken(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend,
        lastTry
      )
    ),
  authorizeWithTokenResend: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      actions.authorizeWithTokenResend(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithTokenLastTry: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      actions.authorizeWithTokenLastTry(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    )
})

export default connect(mapStateToProps, mapDispatchToProps)(RequestAside)



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/RequestAside.js